var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import 'print-this';
var BaseTicketDialog = /** @class */ (function () {
    function BaseTicketDialog() {
    }
    BaseTicketDialog.prototype.activate = function (item) {
        this.item = item;
    };
    BaseTicketDialog.prototype.print = function () {
        this.printElem(this.ticket);
    };
    BaseTicketDialog.prototype.printElem = function (elem) {
        var e_1, _a;
        var w = window.open('', 'PRINT', 'height=400,width=600');
        w.document.write('<html><head><title>' + document.title + '</title>');
        var links = $("link").toArray();
        try {
            for (var links_1 = __values(links), links_1_1 = links_1.next(); !links_1_1.done; links_1_1 = links_1.next()) {
                var item = links_1_1.value;
                var ele = item;
                if (ele.type == "text/css") {
                    var href = ele.href;
                    w.document.write('<link rel="stylesheet" type="text/css" href="' + href + '" />');
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (links_1_1 && !links_1_1.done && (_a = links_1.return)) _a.call(links_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        w.document.write('</head><body>');
        w.document.write(elem.innerHTML);
        console.log(elem.innerHTML);
        w.document.write('</body></html>');
        w.document.close(); // necessary for IE >= 10
        w.focus(); // necessary for IE >= 10*/
        setTimeout(function () {
            w.print();
        }, 1000);
        return true;
    };
    return BaseTicketDialog;
}());
export { BaseTicketDialog };
